import { FormInstance } from "antd"
import { DataType } from "../../../Contexts/UserContext/MovementAcountContext"


export interface TransfersSuppliersProps {
    form: FormInstance<any>,
}

export const toolpipsOptions ={
    extraction:{
        '1': 'Ingresar el monto total entregado por el cliente en la agencia. Sobre este monto se descontará la comisión y se indicará el monto a retirar en el proveedor.',
        '2': 'Ingrese el monto a retirar por el cliente en el proveedor. El sistema indicará el monto que debe depositar en la agencia, calculando las comisiones en base al dinero total a entregar en la agencia.',
        '3': 'Ingrese el monto a retirar por el cliente en el proveedor. El sistema indicará el monto que debe depositar en la agencia, calculando las comisiones en base al dinero total a retirar en el proveedor.' 
    },
    deposit:{
        '1': 'Ingresar el monto total entregado por el cliente al proveedor. Sobre este monto se descontará la comisión y se indicará el monto a retirar en la agencia',
        '2': 'Ingrese el monto a retirar por el cliente en la agencia. El sistema indicará el monto que debe depositar al proveedor, calculando las comisiones en base al dinero total a entregar al proveedor.',
        '3': 'Ingrese el monto a retirar por el cliente en la agencia. El sistema indicará el monto que debe depositar en el proveedor, calculando las comisiones en base al dinero total a retirar en la agencia.'
    }      
}
